export default __webpack_public_path__ + "static/swash-962d0657aae00a42e26ba05ed0152815.svg";